
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import '../styles/tailwind.css';
import '@stereoagency/soehne/index.css';
import '@stereoagency/ui/lib/global.css';
import '../styles/wordpress-blocks.generated.css';
import '../styles/wordpress.css';
import '@egjs/react-flicking/dist/flicking.css';
import PiwikPro from '@piwikpro/react-piwik-pro';
import { motion, AnimatePresence } from 'framer-motion';
import type { AppContext, AppProps } from 'next/app';
import NextApp from 'next/app';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { ImageContextProvider, LinkContextProvider } from '@/components';
import { type SSRData } from '@/utils/withPrepass';
import { URQLProvider } from '@/gql';
type Props = {
    urqlState?: SSRData;
    nonce?: string;
};
if (typeof window !== 'undefined' && process.env.PIWIK_CONTAINER_ID && process.env.PIWIK_CONTAINER_URL) {
    PiwikPro.initialize(process.env.PIWIK_CONTAINER_ID, process.env.PIWIK_CONTAINER_URL);
}
function App({ Component, pageProps }: AppProps<Props>) {
    const router = useRouter();
    const nonce = pageProps.nonce;
    return (<>
      {!!process.env.GTM_ID && (<Script id="google-tag-manager" strategy="afterInteractive" src="/scripts/gtm.js" data-gtm-id={process.env.GTM_ID} nonce={nonce}/>)}
      {!!process.env.GA_MEASUREMENT_ID && (<Script id="google-analytics" strategy="afterInteractive" src="/scripts/gtag.js" data-ga-id={process.env.GA_MEASUREMENT_ID} nonce={nonce}/>)}
      <LinkContextProvider>
        <ImageContextProvider>
            <AnimatePresence initial={false} mode="wait">
              <motion.div key={router?.asPath} className="flex grow" initial={{ opacity: 0 }} exit={{ opacity: 0 }} animate={{
            opacity: 1
        }}>
                <URQLProvider urqlState={pageProps.urqlState}>
                  <Component {...pageProps}/>
                </URQLProvider>
              </motion.div>
            </AnimatePresence>
        </ImageContextProvider>
      </LinkContextProvider>
    </>);
}
App.getInitialProps = async (appContext: AppContext) => {
    const appProps = await NextApp.getInitialProps(appContext);
    const nonce = appContext.ctx.req?.headers?.['x-nonce'] as string | undefined;
    return {
        ...appProps,
        pageProps: {
            ...appProps.pageProps,
            nonce: nonce ?? ''
        }
    };
};

    export default __appWithI18n(App, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  